import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'xh',
    fullName: 'Xhosa',
    nativeName: 'IsiXhosa',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Kukho into emangalisayo iyeza",
    landing_subtitle: "I-ArgVoid lusetyenziso kunye nesitudiyo sophuhliso lomdlalo. Hlala ubukele, izinto ezintsha ziyeza kungekudala!",
    select_language: "Khetha ulwimi",
    search_placeholder: "Phendla iilwimi...",
    terms_title: "Imimmisele yenkonzo",
    policy_title: "Umthetho wabucala",
    cookies_title: "Umgaqo-nkqubo we-cookie",
    terms_content: `
        <strong>1. Ukwamkelwa kwemiGaqo</strong><br>
        Ngokufikelela kwiArgVoid, le Miqathango yeNkonzo yamkelwe. Ukuba le migaqo kungavunyelwana ngayo, inkonzo mayingasetyenziswa.<br>X<br>

        <strong>2. Ukusetyenziswa kweqonga</strong>X<br>
        I-ArgVoid kunye nezicelo zayo zinikezelwa "njengoko kunjalo" ngeenjongo zolwazi kunye nobuchule. Inkonzo kufuneka isetyenziselwe iinjongo ezisemthethweni kuphela.<br>X<br>

        <strong>3. Ukuziphatha okungavumelekanga</strong><br>
        Ukusebenzisa indawo ebuthathaka, spamming, okanye ukuzama ufikelelo olungagunyaziswanga kwiziseko ezingundoqo akuvumelekanga ngokungqongqo.<br><br>

        <strong>4. I-Disclaimer</strong><br>
        Iqonga kunye neenkonzo zinokuguqulwa nangaliphi na ixesha ngaphandle kwesaziso. Akukho siqinisekiso sinikiweyo malunga nexesha okanye ukufumaneka kwenkonzo.
    `,
    policy_content: `
        <strong>1. Ingqokelela yolwazi</strong>X<br>
        Iqonga alifuni ukuqinisekiswa komsebenzisi okanye ukudala iakhawunti ngeli xesha. Akukho lwazi lokuchonga lomntu (olufana namagama okanye idilesi ye-imeyile) eqokelelwa ngokusebenzayo kwiindwendwe.<br><br>

        <strong>2. Ukusetyenziswa kwedatha</strong>X<br>
        Uhlalutyo olusisiseko, olungachazwanga lunokuqokelelwa ukuqonda ukugcwala kwendawo kunye nokuphucula usetyenziso. Le datha ayidityaniswanga nesazisi somsebenzisi ngamnye.<br>X<br>

        <strong>3. Iinkonzo zomntu wesithathu</strong><br>
        Ababoneleli beqela lesithathu banokusetyenziselwa ukusingatha kunye neenkonzo zohlalutyo. Iinkqubo zabucala zaba baboneleli abahlukeneyo zilawula idatha engachazwanga esetyenziwe kwiziseko zabo zokusebenza.<br><br>

        <strong>4. ukhuseleko lwedatha</strong><br>
        Amanyathelo okhuseleko afanelekileyo aphunyezwa ukukhusela iqonga. Nangona kunjalo, akukho ndlela yokudluliselwa kwi-Intanethi ekhuselekile ngokupheleleyo.<br><br>
    `,
    cookies_content: `
        <strong>1. Yintoni iiKuki kunye noGcino lwaseKhaya?</strong><br>
        Iikuki kunye nesikhangeli sogcino lwendawo ziifayile ezincinci zedatha ezigcinwe kwisixhobo ukukhumbula uqwalaselo olukhethwayo kulo lonke utyelelo.<br><br>

        <strong>2. Ukusetyenziswa kweNjongo</strong>X<br>
        UGcino lwaseKhaya lwesikhangeli lusetyenziswa ngokungqongqo ukugcina imimiselo yoqwalaselo, efana ne:<br>
        -Ulwimi olukhethwayo<br>
        -Ubumbeko lojongano lomsebenzisi (umzekelo, uyilo okanye useto lomxholo)<br>
        - I-cache yesicelo sexeshana<br><br>

        <strong>3. Akukho Tracking</strong><br>
        Iikuki kunye nokugcinwa kwendawo akusetyenziselwa intengiso okanye iinjongo zokulandela umkhondo womntu wesithathu. Yonke idatha egciniweyo ingqongqo kwintsebenzo engundoqo yeqonga.<br><br>

        <strong>4. Ulawulo</strong><br>
        Idatha yoMkhangeli inokucocwa nangaliphi na ixesha ngokusebenzisa iisetingi zesikhangeli, eziza kuphinda zisete kwakhona naziphi na izilungiso zendawo.
    `,
    cookie_consent_text: "Sisebenzisa iikuki ezisisiseko ukuqinisekisa ukuba iwebhusayithi isebenza ngokuchanekileyo, njengokugcina ixesha lakho lisebenza, ukugcina ukhetho lwakho lolwimi, kunye nolunye uhlengahlengiso.",
    read_policy: "Funda uMgaqo-nkqubo weKuki",
    support_title: "Qhagamshelana neNkxaso",
    support_subject_label: "Umxholo",
    support_message_label: "Umyalezo",
    support_submit_button: "Thumela uMyalezo",
    support_hint: "Qaphela: Oku kuya kuvula isicelo sakho se-imeyile esihlala sikhona ukuthumela umyalezo.",
    support_success_msg: "Ivula iapp yeimeyile yakho...",
    support_error_msg: "Ayiphumelelanga ukuthumela umyalezo. Nceda uzame kwakhona mva.",
    explorer_title: "Umhloli",
    history_title: "Imbali",
    animation_title: "Oopopayi",
    config_title: "Uqwalaselo",
    tool_mouse: "Khetha (Ctrl+M)",
    tool_brush: "Ibrashi (Ctrl+B)",
    tool_brush_mode: "Imo yokuguqula (Iqinile/ecacileyo)",
    tool_eraser: "Irabha (Ctrl+E)",
    tool_brush_size: "Lungisa ubungakanani bebrashi",
    tool_bucket: "Gcwalisa (Ctrl+F)",
    tool_eyedropper: "I-Eyedropper",
    tool_grid: "Igridi (Ctrl+Shift+B)",
    tool_rotate: "Jikelezisa (Ctrl+Shift+R)",
    tool_flip_h: "Flip H (Ctrl+Shift+H)",
    tool_flip_v: "Flip V (Ctrl+Shift+V)",
    tool_transpose: "Guqula (Ctrl+Shift+T)",
    label_width: "Ububanzi",
    label_height: "Ubude",
    label_frames: "Inani lezakhelo",
    label_animation: "Isimbo soopopayi",
    label_background_color: "Umbala ongasemva",
    label_interval: "Ikhefu",
    tool_anim_config: "Uqwalaselo lopopayi",
    label_new_width: "Ububanzi Obutsha",
    label_new_height: "Ukuphakama Okutsha",
    label_apply: "Faka isicelo",
    label_colors: "Imibala",
    label_size: "Ubungakanani",
    label_tolerance: "Ukunyamezelana",
    val_horizontal: "Ukuthe tye",
    val_vertical: "Ngokuthe nkqo",
    val_sequence: "Ulandelelwano",
    val_bounce: "Bounce",
    val_random: "Ngokuzenzekelayo",
    val_solid: "Iqinile",
    val_clear: "Cacileyo",
    action_add_sheet: "Iphepha elitsha",
    action_import: "Ngenisa ngaphandle",
    action_export: "Thumela ngaphandle",
    action_sort_projects: "Hlela",
    sort_date_old: "Omdala Kuqala",
    sort_date_new: "Entsha Okokuqala",
    sort_name_az: "Igama (A-Z)",
    sort_name_za: "Igama (Z-A)",
    action_new_sprite: "I-Sprite entsha",
    action_new_project: "Iprojekthi entsha",
    modal_save_all_title: "Gcina Zonke Iinguqu",
    modal_save_all_desc: "Khetha ii-asethi oza kuzigcina:",
    modal_save_selected: "Gcina Okukhethiweyo",
    action_saved: "Igciniwe",
    modal_create_sprite_title: "Yenza iSprite eNtsha",
    modal_create_project_title: "Yenza iProjekthi eNtsha",
    modal_add_sheet_title: "Yongeza iPhepha elitsha",
    modal_rename_sheet_title: "Lithiye kwakhona iPhepha",
    modal_rename_sprite_title: "Qamba ngokutsha iSprite",
    modal_delete_sprite_title: "Cima i-Sprite",
    modal_delete_project_title: "Cima iProjekthi",
    modal_delete_sheet_title: "Cima iPhepha",
    placeholder_sprite_name: "Igama",
    placeholder_project_name: "Igama",
    placeholder_sheet_name: "Igama",
    placeholder_new_name: "Igama elitsha",
    action_create: "Yenza",
    action_add: "Yongeza",
    action_rename: "Thiya ngokutsha",
    action_duplicate: "Phinda kabini",
    action_delete: "Cima",
    action_cancel: "Rhoxisa",
    confirm_delete_sprite: "Uqinisekile ufuna ukucima le sprite?",
    confirm_delete_project: "Uqinisekile ufuna ukucima le projekthi? Zonke ii-sprites ziya kususwa.",
    confirm_delete_sheet: "Uqinisekile ufuna ukucima eli phepha?",
    err_select_sprite: "Nceda ukhethe i-sprite kuqala.",
    err_select_project: "Nceda ukhethe iprojekthi kuqala.",
    err_name_empty: "Igama alinakungabi nanto.",
    err_sprite_exists: "I-sprite enelo gama sele ikhona.",
    err_project_exists: "Iprojekthi enelo gama sele ikhona.",
    err_no_content: "Akukho mxholo wokugcinwa.",
    err_no_changes: "Akukho tshintsho luza kugcinwa.",
    err_delete_last_sheet: "Ayikwazi ukucima iphepha lokugqibela.",
    err_extract_frames: "Ayikwazanga kukhupha naziphi na izakhelo.",
    err_indexeddb: "Ayiphumelelanga ukugcina kwindawo. Isikhangeli sakho sisenokungayixhasi i-IndexedDB.",
    msg_upload_success: "ukulayisha kuphumelele: {0}",
    msg_upload_failed: "Ukulayisha Akuphumelelanga: {0}",
    msg_save_success: "Gcina ngempumelelo.",
    msg_saving: "Iyagcina...",
    msg_multi_save_result: "Igciniwe {0} impahla. {1} ukusilela.",
    menu_title: "Imenyu",
    menu_save: "Gcina",
    menu_save_all: "Gcina Konke",
    menu_support: "Qhagamshelana neNkxaso",
    label_local_storage: "Indawo yokugcina",
    label_sign_in: "Ngena",
    modal_export_title: "Thumela ngaphandle Sprite",
    label_filename: "Igama lefayile",
    label_format: "Ifomathi",
    action_export_confirm: "Thumela ngaphandle",
};

export default translations;
